<template>
  <div class="greet-tips-dialog-page" v-if="greetTipsShow">
    <div class="greet-tip-dialog" ref="greetTipDialogMain">
      <div class="top-img"></div>
      <div class="close-btn" @click.stop="hideGreetTips"></div>
      <div class="tips-content">Each greeting will cost 2 coins, buy SVIP to send messages for free.</div>
      <div class="action-btn" @click.stop="sayHi">Say hi to her</div>
      <div :class="'tips '+(showAgain?'':'selected')" @click.stop="toggleShowAgain">Don’t remind again
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../../../router'
  import {localSave} from "../../../utils/tools";
  import global from "../../../config/global";
  import EventBusConstant from "../../../push/const/EventBusConstant";
  import {localGet} from "../../../utils/tools";

  export default {
    name: "greetipsdialog",
    props: {
      greetTipsShow: {
        default: false
      },
      doAfterCallback: {
        default: null,
        type: Function
      },
      doAfterFailedCallback: {
        default: null,
        type: Function
      },
      accountId: ''
    },
    data() {
      return {
        showAgain: true,
      }
    },
    mounted() {
    },
    watch: {
      greetShow(n, o) {
        if (n && localGet(global.getUserDisplay() + global.key.GREET_TIPS_HIDE)) {
          this.greetTipsShow = false
        }
      }
    },
    methods: {
      toggleShowAgain(){
          this.showAgain=!this.showAgain
      },
      hideGreetTips() {
        this.$emit('hideGreetTipsDialog')
        if (!this.showAgain) {
          localSave(global.getUserDisplay() + global.key.GREET_TIPS_HIDE, true)
        }
      },
      sayHi() {
        this.$emit('sayHi', this.accountId,this.doAfterCallback,this.doAfterFailedCallback)
        this.hideGreetTips()
      },
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .greet-tips-dialog-page {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .3);

    .greet-tip-dialog {
      .w(588);
      .h(506);
      top: 50%;
      font-size: 0;
      left: 50%;
      position: relative;
      text-align: center;
      transform: translate(-50%, -50%);
      .b-radius(20);
      background: #fff;

      .top-img {
        .w(286);
        .h(230);
        background: url(../../../assets/imgs/moment/greet_img_sayhi.png) no-repeat center;
        background-size: contain;
        .mt(3);
        display: inline-block;
      }

      .close-btn {
        .w(48);
        .h(48);
        .right(20);
        .top(20);
        background: url(../../../assets/imgs/moment/greet_icon_close.png) no-repeat center;
        background-size: contain;
        position: absolute;
        display: inline-block;
      }

      .tips-content {
        .fs(28);
        font-family: Gilroy-Bold;
        color: #333;
        text-align: center;
        .lh(40);
        .mr(54);
        .ml(54);
        .mt(-6);
      }

      .action-btn {
        .w(360);
        .h(88);
        .mt(20);
        .b-radius(36);
        background: #FF0E74;
        .ml(114);
        text-align: center;

        color: #fff;
        .fs(28);
        .lh(88);
        font-family: Gilroy-Bold;
      }

      .tips {
        .mt(36);
        font-family: Gilroy-Bold;
        color: #aaa;
        .fs(24);
      }

      .tips::before {
        content: '';
        display: inline-block;
        .w(22);
        .h(22);
        background: url("../../../assets/imgs/moment/greet_icon_unselect.png") no-repeat center;
        background-size: contain;
        content: '';
        .mr(5);
        vertical-align: bottom;
      }

      .tips.selected::before {
        content: '';
        display: inline-block;
        .w(22);
        .h(22);
        background: url("../../../assets/imgs/moment/greet_icon_selected.png") no-repeat center;
        background-size: contain;
        content: '';
        .mr(5);
        vertical-align: bottom;
      }


    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/moment/greettipsdialog.vue